<template>
	<div class="account">
		<div class="form-header">
			<p class="form-label">{{ $page.props.lang.account_details || "Account Details" }}</p>
		</div>
		<div class="fields">
			<div class="grid">
				<div class="field-group">
					<p class="label">{{ $page.props.lang.firstName || 'First name' }}</p>
					<v-text-field v-model="form.first_name" outlined dense 
					:error-messages="responseErrors.first_name" @focus="responseErrors.first_name=''"
					></v-text-field>
				</div>
				<div class="field-group">
						<p class="label">{{ $page.props.lang.lastName || 'Last name' }}</p>
						<v-text-field v-model="form.last_name" outlined dense 
						:error-messages="responseErrors.last_name" @focus="responseErrors.last_name=''"></v-text-field>
				</div>
				<div class="field-group">
					<p class="label">{{ $page.props.lang.birthDate || 'Day of birth' }}</p>
					<v-menu
					ref="birthDatePicker"
					v-model="birthDatePicker"
					:close-on-content-click="false"
					:return-value.sync="date"
					transition="scale-transition"
					offset-y
					min-width="290px">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field v-model="formatDatePicker" 
							append-icon="mdi-menu-down" outlined dense readonly v-bind="attrs" v-on="on" 
							@click:append="birthDatePicker = true" :hide-details="!responseErrors.birth_date"></v-text-field>
						</template>
						<v-date-picker
						v-model="form.birth_date" 
						:min="minBirth" :max="yesterday"
						:active-picker.sync="activePicker" 
						:first-day-of-week="1"  no-title scrollable color="primary">
							<v-spacer></v-spacer>
							<v-btn text color="primary" @click="birthDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
							<v-btn text color="primary" @click="birthDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
						</v-date-picker>
					</v-menu>
				</div>
				<div class="field-group">
					<p class="label">{{ $page.props.lang.phone || 'Phone number' }}</p>
					<v-text-field :placeholder="country_code + 'xxxx...'" 
						v-model="form.phone_number"
						:error-messages="responseErrors.phone_number" 
						@focus="responseErrors.phone_number=''"
						:hide-details="!responseErrors.phone_number"
						outlined dense>
					</v-text-field>
				</div>
			</div>
		</div>
		<v-btn @click="submit" :loading="sending" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>

		<v-snackbars :objects.sync="messageObjects" top right>
			<template v-slot:action="{ close }">
				<v-btn text @click="close()" icon><v-icon>mdi-close</v-icon></v-btn>
			</template>
		</v-snackbars>
	</div>

</template>

<script>
import PortalLayout from '@/js/Layouts/PortalLayout';
import ProfileLayout from '@/js/Layouts/ProfileLayout';

import EventBus from '@/js/eventbus';

export default {
	metaInfo() {
        return {
            title: this.organization.name + ' - ' + (this.$page.props.lang.account_details || "Account Details") 
        }
    },
	layout: (h, page) => {
		return h(PortalLayout, [
			h(ProfileLayout, [page]),
		])
	},
	props: {
		member: Object,
		lang: Object,
		organization:Object,
		country_code: String
	},
	data(){
		return {
			customsData: this.customs,
			form: this.member,
            birthDatePicker: false,
			activePicker: null,
            date: moment().format('YYYY-MM-DD'),
            minBirth: moment().subtract(70, 'years').format('YYYY-MM-DD'),
            yesterday: moment().subtract(1, 'days').format('YYYY-MM-DD'),
            messageObjects: [],
            responseErrors: {},
			sending: false
		}
	},
    watch: {
        member(value) {
            this.form = value;
            this.$parent.$emit('edited', this.form);
        },

		birthDatePicker (val) {
        val && setTimeout(() => (this.activePicker = 'YEAR'))
      }

    },
    mounted() {
        this.$parent.$emit('edited', this.form)
    },
    computed: {
        formattedDate() {
            let realDate = new Date(this.form.birth_date)
            let month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][realDate.getMonth()]
            let day = realDate.getDate()
            let year = realDate.getFullYear()
            return day + '. ' + month + ' ' + year + ''
        },

		formatDatePicker(){
            if(this.form.birth_date !== null){
                return moment(this.form.birth_date).format('D.M.Y');
            }else{
                return null;
            }
        },
    },
    methods:{
        submit() {
            this.sending = true
            this.form.birth_date = this.form.birth_date ? moment(this.form.birth_date).format('YYYY-MM-DD') : null;
            axios.post('/portal/profile/save', this.form)
                .then(response => {

					this.sending = false;
					var messageType = "success";
                    if (response.data.status === "OK") {
                        this.$parent.$emit('edited', this.form);
                    }

					EventBus.$emit('SHOW_NOTIFICATION', {
                            message: response.data.message,
                            color: messageType,
                            timeout: 10000
                        });
                })
                .catch(error => {
					this.sending = false;

					EventBus.$emit('SHOW_NOTIFICATION', {
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 5000
                        });

                    this.responseErrors = error.response.data.errors
                });
        }
    }
}
</script>